import { CommonModule } from '@angular/common';
import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';

import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { PageToastMessagesComponent } from 'Angular/features/components/toast-messages/page-toast-messages.component';
import { GlossaryIndexComponent } from 'GlossaryApp/ts/apps/glossary-index-app/components/glossary-index/glossary-index.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    declarations: [GlossaryIndexComponent],
    imports: [
        BrowserModule,
        CommonModule,
        ConfigModule,
        IconModule,
        IconSearchAutocompleteModule,
        NavigationModule,
        PageToastMessagesComponent,
        SideMenuModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
    ],
})
export class AppModule {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(GlossaryIndexComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
